export default __webpack_public_path__ + "static/media/search.d105ae1c.svg";